class LanguageSelector {
  container?: HTMLElement | null;

  constructor() {
    this.container = document.querySelector<HTMLElement>('.arjo-o-language-selector');
    this.calculateTotalItems();

    window.addEventListener('resize', () => this.calculateTotalItems());
  }

  calculateTotalItems() {
    if (!this.container) return;

    const columnNumber = window.getComputedStyle(this.container).getPropertyValue('--column-number');
    const totalItems = window.getComputedStyle(this.container).getPropertyValue('--total-item');
    const rowNumber = Math.ceil(+totalItems / +columnNumber);
    this.container?.style.setProperty('--row-number', rowNumber.toString());
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new LanguageSelector();
});

export {};
